import request from '@/utils/axios_gispai'

/************  要素接口  ************/

// 添加要素
export function addGeoDataFeature(params) {
  return request({
    url: 'api/GeoDataFeature/AddGeoDataFeature',
    method: 'post',
    data: params
  })
}

// 批量添加要素
export function batchAddFeature(params) {
  return request({
    url: '/GeoDataFeature/AddMostGeoDataFeature',
    method: 'post',
    data: params
  })
}

// 批量添加要素
export function batchAddFeatureData(params) {
  return request({
    url: 'api/GeoDataFeature/AddGeoDataFeature_piliang',
    method: 'post',
    data: params
  })
}

// 获取项目的要素数据
export function getFeatureList(params) {
  return request({
    url: '/feature/GetAllGeoDataFeature',
    method: 'get',
    params: params
  })
}

// 获取要素数据(某项目某图层所有数据，或者某项目某图层某任务的数据)
export function getGeoData(params) {
  return request({
    url: '/feature/GetGeoData',
    method: 'get',
    params: params
  })
}

// 导入要素数据
export function importGeoData(params) {
  return request({
    url: '/feature/ImportGeoData',
    method: 'get',
    params: params
  })
}



// 批量更新要素
export function batchUpdateFeature(params) {
  return request({
    url: 'api/GeoDataFeature/UpdateAndGetDataByIDs',
    method: 'POST',
    data: params
  })
}

// 批量更新要素的shape
export function batchUpdateShape(params) {
  return request({
    url: 'api/GeoDataFeature/UpdateGeoDataFeatureForPath_piliang',
    method: 'post',
    data: params
  })
}

// 初始化加载数据
export function initFeature(params) {
  return request({
    url: '/feature/CheckLoadGeoDataFeature',
    method: 'get',
    params: params
  })
}

// 更新要素的图形数据
export function updateFeatureShape(params) {
  return request({
    url: 'api/GeoDataFeature/UpdateGeoDataFeatureForPath',
    method: 'post',
    data: params
  })
}

//根据task取要素数据
export function getFeatureByTask(params) {
  return request({
    url: '/feature/GetGeoDataFeatureWithTask',
    method: 'get',
    params: params
  })
}

//根据taskId批量取要素数据
export function getGeoFeatureByTaskId(params) {
  return request({
    url: '/GeoDataFeature/GetGeoFeatureByTaskId_ALL',
    method: 'get',
    params: params
  })
}


export function getGeoFeature(params) {
  return request({
    url: '/GeoDataFeature/GetGeoFeatureByTaskId',
    method: 'get',
    params: params
  })
}


//根据Id取要素数据
export function getFeatureById(params) {
  return request({
    url: '/feature/GetGeoFeatureById',
    method: 'get',
    params: params
  })
}

//更新要素状态
export function updateFeatureState(params) {
  return request({
    url: '/feature/UpdateGeoDataFeatureState',
    method: 'get',
    params: params
  })
}

//更新要素属性
export function updateFeatureAttr(params) {
  return request({
    url: 'api/GeoDataFeature/UpdateGeoDataFeatureAttr',
    method: 'post',
    data: params
  })
}


//删除要素
export function delByLayerName(params) {
  return request({
    url: '/feature/DeleteGeoWithLayerName',
    method: 'get',
    params: params
  })
}

//根据图层名获取所有整个项目的矢量数据
export function getByLayerName(params) {
  return request({
    url: '/GeoDataFeature/GetGeoFeatureByLayerName',
    method: 'get',
    params: params
  })
}

//根据项目编号、任务编号、图层名来获取图层的矢量数据
export function getShpFeature(params) {
  return request({
    url: '/feature/GetShpGeoFeature',
    method: 'get',
    params: params
  })
}

//根据查询条件取要素数据
export function getFeatureBySelectCondition(params) {
  return request({
    url: '/feature/GetGeoFeatureBySelectCondition',
    method: 'get',
    params: params
  })
}

//唯一值渲染根据字段名称获取分类后的数据
export function getFeatureByClassify(params) {
  return request({
    url: 'api/GeoDataFeature/GetAttr',
    method: 'get',
    params: params
  })
}

//
export function updateGeoDataFeatureForState(params) {
  return request({
    url: 'api/GeoDataFeature/UpdateGeoDataFeatureForState',
    method: 'post',
    data: params
  })
}
//判断任务范围内是否有数据
export function IsExistData(params) {
  return request({
    url: 'api/GeoDataFeature/IsExist_Data',
    method: 'get',
    params: params
  })
}
export function updateStateByIDs(params) {
  return request({
    url: 'api/GeoDataFeature/UpdateStateByIDs',
    method: 'post',
    data: params
  })
}

export function batchUpdateAttr(params) {
  return request({
    url: "api/GeoDataFeature/UpdateGeoDataFeatureAttrBatch",
    method: 'post',
    data: params
  })
}

//添加字段
export function addGData_Field(params) {
  return request({
    url: "api/GeoDataFeature/AddGData_Field",
    method: 'get',
    params: params
  })
}
//删除字段
export function delGData_Field(params) {
  return request({
    url: "api/GeoDataFeature/DeleteGData_Field",
    method: 'get',
    params: params
  })
}

//更新字段
export function updateGData_Field(params) {
  return request({
    url: "api/GeoDataFeature/UpdateGData_Field",
    method: 'get',
    params: params
  })
}
//字段计算/api/GeoDataFeature/FieldCalculation
export function fieldCalculation(params) {
  return request({
    url: "api/GeoDataFeature/FieldCalculation",
    method: 'post',
    data: params
  })
}
//获取字段不重复值/api/GeoDataFeature/GetFieldAttrUniqueValue
export function GetFieldAttrUniqueValue(params) {
  return request({
    url: "api/GeoDataFeature/GetFieldAttrUniqueValue",
    method: 'get',
    params: params
  })
}
//属性查询
export function GetAttrByCondition(params) {
  return request({
    url: "/api/GeoDataFeature/GetAttrByCondition",
    method: 'get',
    params: params
  })
}

//查询唯一值
export function getAttrUniqueValue(params) {
  return request({
    url: "/api/GeoDataFeature/GetFieldAttrUniqueValue",
    method: 'get',
    params: params
  })
}
//查询分级最大最小值
export function getClassBreakValueByField(params) {
  return request({
    url: "/api/GeoDataFeature/GetMaxAndMinValueByFieldSingle",
    method: 'get',
    params: params
  })
}
//自动构面
export function AutomaticFormFace(params) {
  return request({
    url: "api/GeoDataFeature/AutomaticFormFace",
    method: 'post',
    data: params
  })
}
//后台擦除/api/GeoDataFeature/EraseFace
export function EraseFace(params) {
  return request({
    url: "api/GeoDataFeature/EraseFace",
    method: 'post',
    data: params
  })
}
//后台裁剪/api/GeoDataFeature/TailoringFace
export function TailoringFace(params) {
  return request({
    url: "api/GeoDataFeature/TailoringFace",
    method: 'post',
    data: params
  })
}
//获取要素图形形状/api/GData/GetGeoDataFeaturesingle
export function GetSingleGeoDataFeature(params) {
  return request({
    url: "api/GData/GetGeoDataFeaturesingle",
    method: 'get',
    params: params
  })
}
//后台平滑操作
export function SmoothFace(params) {
  return request({
    url: "/api/GeoDataFeature/SmoothFace",
    method: 'post',
    data: params
  })
}
//后台简化操作
export function SimplifyFace(params) {
  return request({
    url: "/api/GeoDataFeature/SimplifyFace",
    method: 'post',
    data: params
  })
}
//后台打散
export function SeparateFace(params) {
  return request({
    url: "/api/GeoDataFeature/SeparateFace",
    method: 'post',
    data: params
  })
}
//后台合并/
export function MergeFace(params) {
  return request({
    url: "/api/GeoDataFeature/MergeFace",
    method: 'post',
    data: params
  })
}
//复制粘贴数据/api/GeoDataFeature/CopyGeometry
export function CopyGeometry(params) {
  return request({
    url: "/api/GeoDataFeature/CopyGeometry",
    method: 'post',
    data: params
  })
}


export function getAttrBatch(params) {
  return request({
    url: "/api/GeoDataFeature/getAttrLis",
    method: 'post',
    data: params
  })
}
//修改多条属性（批量赋值）
export function updateAttrsingleBatch(params) {
  return request({
    url: "/api/GeoDataFeature/updateAttrsingleBatch",
    method: 'post',
    data: params
  })
}
//挖空
export function HollowingFace(params) {
  return request({
    url: "/api/GeoDataFeature/HollowingFace",
    method: 'post',
    data: params
  })
}
//分割面
export function LineCutFace(params) {
  return request({
    url: "/api/GeoDataFeature/LineCutFace",
    method: 'post',
    data: params
  })
}
//后台打断线
export function SplitLineByPoint(params) {
  return request({
    url: "/api/GeoDataFeature/SplitLineByPoint",
    method: 'post',
    data: params
  })
}
//后端整形

export function ReshapePolygonByLine(params) {
  return request({
    url: "/api/GeoDataFeature/ReshapePolygonByLine",
    method: 'post',
    data: params
  })
}
//后端平移TranslationPolygon
export function TranslationPolygon(params) {
  return request({
    url: "/api/GeoDataFeature/TranslationPolygon",
    method: 'post',
    data: params
  })
}
//判断该要素是否被锁
export function IsGeoLock(params) {
  return request({
    url: "/api/GeoLock/IsGeoLock",
    method: 'post',
    data: params
  })
}
///添加要素锁定锁
export function AddGeoLock(params) {
  return request({
    url: "/api/GeoLock/AddGeoLock",
    method: 'post',
    data: params
  })
}
///批量添加要素锁定锁
export function AddGeoLockBatch(params) {
  return request({
    url: "/api/GeoLock/AddGeoLockBatch",
    method: 'post',
    data: params
  })
}
///删除要素锁定锁
export function DeleteGeoLock(params) {
  return request({
    url: "/api/GeoLock/DeleteGeoLock",
    method: 'post',
    data: params
  })
}
///批量删除要素锁定锁
export function DeleteGeoLockBatch(params) {
  return request({
    url: "/api/GeoLock/DeleteGeoLockBatch",
    method: 'post',
    data: params
  })
}
///api/GeoLock/GetIsGeoLockBatch
//判断该要素集合是否被锁
export function IsGeoLockBatch(params) {
  return request({
    url: "api/GeoLock/GetIsGeoLockBatch",
    method: 'post',
    data: params
  })
}
//溯源列表
export function GetTraceList(params) {
  return request({
    url: "api/Trace/GetTraceList",
    method: 'post',
    data: params
  })
}
//溯源信息
export function GetTraceDetails(params) {
  return request({
    url: "api/Trace/GetTraceDetails",
    method: 'post',
    data: params
  })
}
///恢复
export function TraceRecovery(params) {
  return request({
    url: "api/Trace/TraceRecovery",
    method: 'post',
    data: params
  })
}
